import apiCaller from "./api-caller";

class AuthService {
  login(user) {
    if (localStorage.getItem("user")) {
      localStorage.removeItem("user");
    }

    const { mail, password } = user;
    return apiCaller
      .post("/auth/login", {
        mail,
        password,
      })
      .then((response) => {
        if (response.status >= 400 && response.status <= 499) {
          throw "Credenciales incorrectas";
        } else if (!response.data?.token) {
          throw response.data?.message || "No se ha podido iniciar sesión";
        }

        localStorage.setItem("user", JSON.stringify(response.data));
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }
}

export default new AuthService();
